import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "as-is-first-score__head" }
const _hoisted_2 = { class: "as-is-first-score__body" }
const _hoisted_3 = { class: "as-item" }
const _hoisted_4 = { class: "as-item__left" }
const _hoisted_5 = { class: "as-team" }
const _hoisted_6 = { class: "as-team__img" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "as-team__info" }
const _hoisted_9 = { class: "as-line" }
const _hoisted_10 = { class: "as-item__right" }
const _hoisted_11 = { class: "as-item" }
const _hoisted_12 = { class: "as-item__left" }
const _hoisted_13 = { class: "as-team" }
const _hoisted_14 = { class: "as-team__img" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "as-team__info" }
const _hoisted_17 = { class: "as-line" }
const _hoisted_18 = { class: "as-item__right" }
const _hoisted_19 = { class: "as-history" }
const _hoisted_20 = { class: "as-history-item" }
const _hoisted_21 = { class: "as-history-item__head" }
const _hoisted_22 = { class: "as-history-item__body" }
const _hoisted_23 = { class: "as-competition" }
const _hoisted_24 = { class: "as-competition__table" }
const _hoisted_25 = { class: "as-center a" }
const _hoisted_26 = { class: "as-center a" }
const _hoisted_27 = { class: "as-competition" }
const _hoisted_28 = { class: "as-competition__table" }
const _hoisted_29 = { class: "as-center a" }
const _hoisted_30 = { class: "as-center a" }

import IconGoalScored from '~src/components/icons/foot_stats/IconGoalScored.vue';
    import type { IMatch } from '~src/interfaces';
    import type { IFootyStats, ITeam, IStatsParent } from '~src/interfaces/footystats';
    import { ref } from 'vue';
import { getClassForItem, getImageUrl } from '~src/helpers/footystats';

    
const __default__ = {};

interface Props{
        match: IMatch;
        mode?: string;
        footyStats: IFootyStats | null;
        homeTeamInfo: ITeam | null;
        awayTeamInfo: ITeam | null;
    }

    
export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'WhoIsFirstScore',
  props: {
    match: {},
    mode: { default: 'as-win' },
    footyStats: {},
    homeTeamInfo: {},
    awayTeamInfo: {}
  },
  setup(__props: any) {

    const props = __props

    const activeTab = ref('all')
    const setActiveTab = (tab: string) => {
        activeTab.value = tab;
    };


    const getValueWithMode = (team = 'home', mode = 'btts', is_percent = true, is_last_x = true) => {
        const __data: IStatsParent | null = 
            props.footyStats 
                ? (team === 'home' 
                    ? props.footyStats.home_team_last_x 
                    : props.footyStats.away_team_last_x) 
                : null;

        // let __key = `${mode}_${team}`;
        let __key = `${mode}`;
        if (!__data || !__data.stats || !__data.stats.hasOwnProperty(__key)) {
            return 0; 
        }
        
        const __stats = __data.stats;

        let __total: number = Number(__stats.seasonMatchesPlayedGoalTimingRecorded_overall ?? 0);

        if (activeTab.value === 'scored') {
            __total = Number(props?.footyStats?.season_data?.goalTimingsRecorded_num ?? 0);
        } else if (activeTab.value === 'conceded') {
            __total = Number(props?.footyStats?.season_data?.cornerTimingRecorded_matches_overall ?? 0);
        }

        let res: number = Number(__stats[__key] ?? 0);
        if(!is_last_x){
            const __data: ITeam | null = 
            props.footyStats 
                ? (team === 'home' 
                    ? props.footyStats.home_team_info 
                    : props.footyStats.away_team_info) 
                : null;
            if(!__data?.stats || !__data.stats.stats){
                return 0;
            }    

            return (__data.stats.stats[__key] > 100 ? 100 : __data.stats.stats[__key]) as number;
        }
        if(!is_percent){
            return res;
        }

        if(__total){
            let _percent = (res / __total) * 100 

            return Math.floor(_percent); 

            // return `${res} - ${__total} - ${Math.floor(_percent)}`; 
        }

        return 0
        
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`as-is-first-score ${_ctx.mode}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(IconGoalScored, { fill: "#FFAE00" }),
      _cache[3] || (_cache[3] = _createElementVNode("span", null, " Đội nào sẽ ghi bàn đầu tiên? ", -1))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: _unref(getImageUrl)(_ctx.footyStats?.home_image)
              }, null, 8, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.footyStats?.home_name), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "as-line__as-main" }, null, -1)),
            _createElementVNode("div", {
              class: "as-line__as-W",
              style: _normalizeStyle({
                            width: `${ getValueWithMode('home', 'firstGoalScoredPercentage_overall', false, false) }%`
                        })
            }, null, 4)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", null, _toDisplayString(getValueWithMode('home', 'firstGoalScoredPercentage_overall', false, false)) + "%", 1),
          _createElementVNode("span", null, "Ghi bàn đầu tiên trong " + _toDisplayString(getValueWithMode('home', 'firstGoalScored_overall', false, false)) + "/" + _toDisplayString(getValueWithMode('home', 'seasonMatchesPlayed_overall', false, false)) + " trận", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("img", {
                src: _unref(getImageUrl)(_ctx.footyStats?.away_image)
              }, null, 8, _hoisted_15)
            ]),
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.footyStats?.away_name), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "as-line__as-main" }, null, -1)),
            _createElementVNode("div", {
              class: "as-line__as-D",
              style: _normalizeStyle({
                            width: `${ getValueWithMode('away', 'firstGoalScoredPercentage_overall', false, false) }%`
                        })
            }, null, 4)
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("span", null, _toDisplayString(getValueWithMode('away', 'firstGoalScoredPercentage_overall', false, false)) + "%", 1),
          _createElementVNode("span", null, "Ghi bàn đầu tiên trong " + _toDisplayString(getValueWithMode('away', 'firstGoalScored_overall', false, false)) + "/" + _toDisplayString(getValueWithMode('away', 'seasonMatchesPlayed_overall', false, false)) + " trận", 1)
        ])
      ])
    ]),
    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "as-goals-per-minute" }, [
      _createElementVNode("h5", null, "Bàn thắng theo phút")
    ], -1)),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", {
            class: _normalizeClass(["as-head-tab as-uppercase", { 'as-active': activeTab.value === 'all' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (setActiveTab('all')))
          }, " TS bàn thắng ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["as-head-tab as-uppercase", { 'as-active': activeTab.value === 'scored' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (setActiveTab('scored')))
          }, " Đã ghi bàn ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["as-head-tab as-uppercase", { 'as-active': activeTab.value === 'conceded' }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (setActiveTab('conceded')))
          }, " Bị thủng lưới ", 2)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("table", _hoisted_24, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _cache[6] || (_cache[6] = _createElementVNode("th", null, "Mỗi 10 phút", -1)),
                  _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.footyStats?.home_name), 1),
                  _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.footyStats?.away_name), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[7] || (_cache[7] = _createElementVNode("td", null, "0 - 10 phút", -1)),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', `goals_${activeTab.value}_min_0_to_10`))}`)
                  }, _toDisplayString(getValueWithMode('home', `goals_${activeTab.value}_min_0_to_10`)) + "%", 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', `goals_${activeTab.value}_min_0_to_10`))}`)
                  }, _toDisplayString(getValueWithMode('away', `goals_${activeTab.value}_min_0_to_10`)) + "%", 3)
                ]),
                _createElementVNode("tr", null, [
                  _cache[8] || (_cache[8] = _createElementVNode("td", null, "11 - 20 phút", -1)),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', `goals_${activeTab.value}_min_11_to_20`))}`)
                  }, _toDisplayString(getValueWithMode('home', `goals_${activeTab.value}_min_11_to_20`)) + "%", 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', `goals_${activeTab.value}_min_11_to_20`))}`)
                  }, _toDisplayString(getValueWithMode('away', `goals_${activeTab.value}_min_11_to_20`)) + "%", 3)
                ]),
                _createElementVNode("tr", null, [
                  _cache[9] || (_cache[9] = _createElementVNode("td", null, "21 - 30 phút", -1)),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', `goals_${activeTab.value}_min_21_to_30`))}`)
                  }, _toDisplayString(getValueWithMode('home', `goals_${activeTab.value}_min_21_to_30`)) + "%", 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', `goals_${activeTab.value}_min_21_to_30`))}`)
                  }, _toDisplayString(getValueWithMode('away', `goals_${activeTab.value}_min_21_to_30`)) + "%", 3)
                ]),
                _createElementVNode("tr", null, [
                  _cache[10] || (_cache[10] = _createElementVNode("td", null, "31 - 40 phút", -1)),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', `goals_${activeTab.value}_min_31_to_40`))}`)
                  }, _toDisplayString(getValueWithMode('home', `goals_${activeTab.value}_min_31_to_40`)) + "%", 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', `goals_${activeTab.value}_min_31_to_40`))}`)
                  }, _toDisplayString(getValueWithMode('away', `goals_${activeTab.value}_min_31_to_40`)) + "%", 3)
                ]),
                _createElementVNode("tr", null, [
                  _cache[11] || (_cache[11] = _createElementVNode("td", null, "41 - 50 phút", -1)),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', `goals_${activeTab.value}_min_41_to_50`))}`)
                  }, _toDisplayString(getValueWithMode('home', `goals_${activeTab.value}_min_41_to_50`)) + "%", 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', `goals_${activeTab.value}_min_41_to_50`))}`)
                  }, _toDisplayString(getValueWithMode('away', `goals_${activeTab.value}_min_41_to_50`)) + "%", 3)
                ]),
                _createElementVNode("tr", null, [
                  _cache[12] || (_cache[12] = _createElementVNode("td", null, "51 - 60 phút", -1)),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', `goals_${activeTab.value}_min_51_to_60`))}`)
                  }, _toDisplayString(getValueWithMode('home', `goals_${activeTab.value}_min_51_to_60`)) + "%", 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', `goals_${activeTab.value}_min_51_to_60`))}`)
                  }, _toDisplayString(getValueWithMode('away', `goals_${activeTab.value}_min_51_to_60`)) + "%", 3)
                ]),
                _createElementVNode("tr", null, [
                  _cache[13] || (_cache[13] = _createElementVNode("td", null, "61 - 70 phút", -1)),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', `goals_${activeTab.value}_min_61_to_70`))}`)
                  }, _toDisplayString(getValueWithMode('home', `goals_${activeTab.value}_min_61_to_70`)) + "%", 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', `goals_${activeTab.value}_min_61_to_70`))}`)
                  }, _toDisplayString(getValueWithMode('away', `goals_${activeTab.value}_61_to_70`)) + "%", 3)
                ]),
                _createElementVNode("tr", null, [
                  _cache[14] || (_cache[14] = _createElementVNode("td", null, "71 - 80 phút", -1)),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', `goals_${activeTab.value}_min_71_to_80`))}`)
                  }, _toDisplayString(getValueWithMode('home', `goals_${activeTab.value}_min_71_to_80`)) + "%", 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', `goals_${activeTab.value}_min_71_to_80`))}`)
                  }, _toDisplayString(getValueWithMode('away', `goals_${activeTab.value}_min_71_to_80`)) + "%", 3)
                ]),
                _createElementVNode("tr", null, [
                  _cache[15] || (_cache[15] = _createElementVNode("td", null, "81 - 90 phút", -1)),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', `goals_${activeTab.value}_min_81_to_90`))}`)
                  }, _toDisplayString(getValueWithMode('home', `goals_${activeTab.value}_min_81_to_90`)) + "%", 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', `goals_${activeTab.value}_min_81_to_90`))}`)
                  }, _toDisplayString(getValueWithMode('away', `goals_${activeTab.value}_min_81_to_90`)) + "%", 3)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("table", _hoisted_28, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _cache[16] || (_cache[16] = _createElementVNode("th", null, "Mỗi 15 phút", -1)),
                  _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.footyStats?.home_name), 1),
                  _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.footyStats?.away_name), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[17] || (_cache[17] = _createElementVNode("td", null, "0 - 15 phút", -1)),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', `goals_${activeTab.value}_min_0_to_15`))}`)
                  }, _toDisplayString(getValueWithMode('home', `goals_${activeTab.value}_min_0_to_15`)) + "%", 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', `goals_${activeTab.value}_min_0_to_15`))}`)
                  }, _toDisplayString(getValueWithMode('away', `goals_${activeTab.value}_min_0_to_15`)) + "%", 3)
                ]),
                _createElementVNode("tr", null, [
                  _cache[18] || (_cache[18] = _createElementVNode("td", null, "16 - 30 phút", -1)),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', `goals_${activeTab.value}_min_16_to_30`))}`)
                  }, _toDisplayString(getValueWithMode('home', `goals_${activeTab.value}_min_16_to_30`)) + "%", 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', `goals_${activeTab.value}_min_16_to_30`))}`)
                  }, _toDisplayString(getValueWithMode('away', `goals_${activeTab.value}_min_16_to_30`)) + "%", 3)
                ]),
                _createElementVNode("tr", null, [
                  _cache[19] || (_cache[19] = _createElementVNode("td", null, "31 - 45 phút", -1)),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', `goals_${activeTab.value}_min_31_to_45`))}`)
                  }, _toDisplayString(getValueWithMode('home', `goals_${activeTab.value}_min_31_to_45`)) + "%", 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', `goals_${activeTab.value}_min_31_to_45`))}`)
                  }, _toDisplayString(getValueWithMode('away', `goals_${activeTab.value}_min_31_to_45`)) + "%", 3)
                ]),
                _createElementVNode("tr", null, [
                  _cache[20] || (_cache[20] = _createElementVNode("td", null, "46 - 60 phút", -1)),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', `goals_${activeTab.value}_min_46_to_60`))}`)
                  }, _toDisplayString(getValueWithMode('home', `goals_${activeTab.value}_min_46_to_60`)) + "%", 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', `goals_${activeTab.value}_min_46_to_60`))}`)
                  }, _toDisplayString(getValueWithMode('away', `goals_${activeTab.value}_min_46_to_60`)) + "%", 3)
                ]),
                _createElementVNode("tr", null, [
                  _cache[21] || (_cache[21] = _createElementVNode("td", null, "61 - 85 phút", -1)),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', `goals_${activeTab.value}_min_61_to_85`))}`)
                  }, _toDisplayString(getValueWithMode('home', `goals_${activeTab.value}_min_61_to_85`)) + "%", 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', `goals_${activeTab.value}_min_61_to_85`))}`)
                  }, _toDisplayString(getValueWithMode('away', `goals_${activeTab.value}_min_61_to_85`)) + "%", 3)
                ]),
                _createElementVNode("tr", null, [
                  _cache[22] || (_cache[22] = _createElementVNode("td", null, "85 - 90 phút", -1)),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('home', `goals_${activeTab.value}_min_86_to_90`))}`)
                  }, _toDisplayString(getValueWithMode('home', `goals_${activeTab.value}_min_86_to_90`)) + "%", 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(`as-center ${_unref(getClassForItem)(getValueWithMode('away', `goals_${activeTab.value}_min_86_to_90`))}`)
                  }, _toDisplayString(getValueWithMode('away', `goals_${activeTab.value}_min_86_to_90`)) + "%", 3)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 2))
}
}

})